const Navbar = { 
  background: "#2C3E50",  // Azul profundo
  btnActivo: "#3498DB",   // Azul cielo
  btns: "#ECF0F1",        // Gris muy claro
  btnBackground: "#34495E" // Azul grisáceo
};

export {Navbar}
